import React from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { companyID } from "../../auth";
import api from "../../api/axios";

const GoalActivationModal = ({
  show,
  handleClose,
  activationState,
  handleData,
  fetchConfiguration,
  goalConfigurationData,
  activationType,
}) => {
  const handleSubmit = async (data) => {
    const emp_id = localStorage.getItem("employeeID");
    const company_id = companyID();
    const configData = { data, goalConfigurationData };

    try {
      const response = await api.post(
        `performance/update-goal-activation-status?employee_id=${emp_id}&company_id=${company_id}&activationType=${activationType}&activationState=${activationState}`,
        configData
      );
      if (response?.data?.success == true) {
        fetchConfiguration();
        handleClose();
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      centered
      onHide={handleClose}
    >
      <Modal.Header>
        <div className="d-flex justify-content-between w-100 align-items-center">
          <h4>
            {activationType} Of {handleData?.cycle_name}
          </h4>
          <i
            class="btn p-0 text-danger fa-solid fa-xmark"
            onClick={handleClose}
            // style={{ marginRight: "-10px" }}
          ></i>
        </div>
      </Modal.Header>
      <Modal.Body>
        <p>
          {activationState == false
            ? `Are you sure want to inactive ?`
            : `Are you sure want to active ?`}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          style={{ marginRight: "10px" }}
          variant="secondary"
          onClick={handleClose}
        >
          Close
        </Button>
        <Button
          variant={activationState == false ? `danger` : `success`}
          onClick={() => handleSubmit(handleData)}
        >
          {activationState == false ? `Inactive` : `Active`}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default GoalActivationModal;
